/*global googletag, window*/

import { AMAZON_AD_SIZES } from './constants.js';

/**
 * LoadAmazonAds
 *
 * @class LoadAmazonAds
 * @constructor
 * @param {slots} slots of ads to load
 * @param {loadAds} callback to load ads
 */

const getWindowDimensions = function() {
  var width = window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
  var height = window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
  return [width, height];
};

const parseSizeMappings = function(windowDimensions, sizeMappings) {
  try
  {
    // filter mappings that are valid by confirming that the current screen dimensions
    // are both greater than or equal to the breakpoint [x, y] minimums specified in the first position in the mapping
    var validMappings = sizeMappings.filter(function(m) {return  m[0][0] <= windowDimensions[0] && m[0][1] <= windowDimensions[1]});

    // return the leftmost mapping's sizes or an empty array
    return validMappings.length > 0 ? validMappings[0][1] : [];
  }
  catch (e) {
    // fallback to last size mapping supplied
    return sizeMappings[sizeMappings.length-1][1];
  }
};

const arrayMatch = function(array1, array2) {
  return array1[0] === array2[0] && array1[1] === array2[1];
};

const isAmazonSize = function(adSize) {
  if (!Array.isArray(adSize)) {
    return false;
  }
  if (adSize.length != 2) {
    return false;
  }
  for (var i=0; i<AMAZON_AD_SIZES.length; i++) {
    if (arrayMatch(adSize, AMAZON_AD_SIZES[i])) {
      return true;
    }
  }
  return false;
};

const formatAmazonSize = function (adSizes) {
  for (var i=adSizes.length; i>=0; i--) {
    if (!isAmazonSize(adSizes[i])) {
      adSizes.splice(i, 1);
    }
  }
  return adSizes;
};

const getAmazonSlotForCurrentSize = function(amazon_slot, windowDimensions) {
  var adSizes = amazon_slot.size_mappings ? parseSizeMappings(windowDimensions, amazon_slot.size_mappings) : amazon_slot.sizes;
  return {
    slotID: amazon_slot.slotID,
    slotName: amazon_slot.slotName,
    sizes: formatAmazonSize(adSizes)
  };
};

const getAmazonSlots = function(slots) {
  var windowDimensions = getWindowDimensions();
  var amazonSlotsForCurrentSize = [];
  slots.forEach(function (slot) {
    if (slot) {
      var amazon_slot =  window.amazon_slots.filter(function(m) {return m.slotID === slot.getSlotElementId()});
      if (amazon_slot.length > 0) {
        var amazonSlot = getAmazonSlotForCurrentSize(amazon_slot[0], windowDimensions);
        if (amazonSlot.sizes.length > 0) {
          amazonSlotsForCurrentSize.push(amazonSlot);
        }
      }
    }
  });
  return amazonSlotsForCurrentSize;
};

const ApstagInit = function() {
  //Initialize Amazon Library
  window.apstag.init({
    pubID: '3103',
    adServer: 'googletag'
  });
};

const LoadAmazonAdSlots = function (slots) {
  return new Promise(function(resolve) {
    var amazonSlots = [];
    if (window.apstag !== undefined) {
      amazonSlots = getAmazonSlots(slots);
    }
    if (amazonSlots.length) {
      ApstagInit();
      window.apstag.fetchBids(
        {
          slots: amazonSlots,
          timeout: 2e3
        },
        function () {
          googletag.cmd.push(function() {
            window.apstag.setDisplayBids();
            resolve();
          });
        }
      );
    }
    else {
      resolve();
    }
  });
};

export const LoadAmazonAds = LoadAmazonAdSlots;



// WEBPACK FOOTER //
// ./shared_critical/media/amazon.js